module.exports = __webpack_public_path__ + "img/okcupid.a808d46.png";